export enum SupplierStoreTarget {
  ADMIN = "ADMIN",
  ORGANISER_COMPANY = "ORGANISER_COMPANY",
  RECOMMENDED = "RECOMMENDED",
}
